import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ExamCompleteModel } from '@src/models/examComplete.model';
import { ExamFinishedModel } from '@src/models/examFinished.model';
import { BaseService } from '../services/baseService.service';
import { ExamInfo, ExamBaseData } from '@src/models/examInfo.model';

@Injectable(
    // Instead of providers array you can use provideIn
    // Learn more https://angular.io/guide/providers
    // {
    //     providedIn: "root"
    // }
)
export class KbwService extends BaseService {

    constructor(private http: HttpClient) {
        super();
     }

    getData<ExamCompleteModel>() {
        const headers = this.createRequestHeader();
        return this.http.get<ExamCompleteModel>(`${this.serverUrl}/exam/getexamdata`, { headers: headers });
    }

    sendFinishExamData<ExamSummary>(model: ExamFinishedModel) {
        const headers = this.createRequestHeader();
        return this.http.post<ExamSummary>(`${this.serverUrl}/exam/CheckExamData`,
        model, {headers: headers});
    }
    getExams<ExamBaseData>(bookType: any) {
        const headers = this.createRequestHeader();
        const params = new HttpParams().append('bookType', bookType);
        return this.http.get<ExamBaseData>(`${this.serverUrl}/user/GetTrainingTypes`, { headers: headers, params: params});
    }
    postExams<ExamBaseData>(bookType: any, examCodes: Array<string>) {
        const headers = this.createRequestHeader();
        const params = { 'BookType': bookType, 'ExamCodes': examCodes };
        return this.http.post<ExamBaseData>(`${this.serverUrl}/user/PostTrainingTypes`,
          params, { headers: headers });
    }

    // private createRequestHeader() {
    //     // set headers here e.g.
    //     let headers = new HttpHeaders({
    //         // "AuthKey": "my-key",
    //         // "AuthToken": "my-token",
    //         "Content-Type": "application/json",
    //         "Access-Control-Allow-Origin": "*"
    //     });

    //     return headers;
    // }
}